import styled, { keyframes } from "styled-components";

export const Background = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   background-color: #f1a9ca;
`
export const Padding = styled.div`
    min-height: 100px;
`
export const OppGradient = styled.div`
    background: linear-gradient(#cbb9d9, #f1a9ca);
    min-height: 200px;
    @media (max-width: 767px) {
        min-height: 50px;
    }
`
export const Paragraph = styled.p`
    text-align: center;
    font-size: 2.2rem;
    font-family: 'KiwiSoda';
    color: #420942;
    margin: auto;
    max-width: 50%;
    padding: 10px;
    @media (max-width: 767px) {
        max-width: 80%;
    }

`
export const IF = styled.iframe`
    margin: auto;
    width: 80%;
    padding: 10px;
    @media (max-width: 767px) {
        width: 90%;
    }
` 
export const IconContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    
`
export const IconAnim = keyframes`
    0%{
        transform: scale(1);
    }
    100%{
        transform: scale(1.2);
    }

`
export const ReverseIconAnim = keyframes`
    0%{
        transform: scale(1.2);
    }
    100%{
        transform: scale(1);
    }
`
export const Icon = styled.img`
    max-width: 64px;
    padding-left:20px;
    animation-name: ${ReverseIconAnim};
        animation-duration: 500ms;
        animation-fill-mode: forwards;
    
        &:hover{
            animation-name: ${IconAnim};
            animation-duration: 100ms;
            animation-fill-mode: forwards;
        }
    
`
export const SocialLink = styled.a`
    
`